// 导入用户+优惠券
import request from '@/utils/request';

// 上传文件
export function uploadImportFile(data) {
  return request({
    url: '/admin/upload/file',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}

// 触发后端导入
export function importUserCoupon(data) {
  return request({
    url: '/admin/import/user-coupon',
    method: 'post',
    data: data
  });
}